import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './styles/app.css';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import { trackSignUpIfNew } from './utils/ga';
import { rememberSignedIn } from './utils/authMemory';

serviceWorker.unregister();

// GA4 sign_up for every new account, whichever page created it.
onAuthStateChanged(auth, (user) => {
  trackSignUpIfNew(user);
  rememberSignedIn(user);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Defer vitals so they do not compete with first paint / LCP.
const bootVitals = () => {
  import('./reportWebVitals').then((m) => m.default());
};
if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
  window.requestIdleCallback(bootVitals, { timeout: 4000 });
} else {
  window.setTimeout(bootVitals, 2000);
}
